import './instrument'; // Sentry must be imported first
import 'core-js';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import './styles.css';
import './react-tagsinput.css';
// import Sockets from './components/Sockets';
import * as serviceWorker from './serviceWorker';
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import Routes from './Routes';
import AxiosAPI from './helpers/axios';
import store from './store';
import App from 'components/App';


import 'bootstrap/dist/css/bootstrap.min.css';
import 'flag-icons/css/flag-icons.min.css';
import 'typeface-roboto';

Chart.register(ChartDataLabels);
Chart.defaults.set('plugins.datalabels', {
  display: false,
});


//Creates axios interceptors for requests
new AxiosAPI();

if (localStorage.token) {
  try {
    (window as any).webkit?.messageHandlers?.setAuthorizationToken?.postMessage(localStorage.token);
  } catch { }
}

ReactDOM.render(
  // @ts-ignore - Sentry ErrorBoundary types expect React 18+ but works with React 17
  <Sentry.ErrorBoundary fallback={<p>An unexpected error occurred. Please reload the page.</p>}>
    <Provider store={store}>
      {/* <Sockets store={store} /> */}
      <Router>
        <App>
          <Routes />
        </App>
      </Router>
    </Provider>
  </Sentry.ErrorBoundary>,
  document.getElementById('root'),
);

serviceWorker.unregister();
